export default "__VITE_ASSET__B42Iwr9$__"